import * as React from 'react';
import { FC } from 'react';
import type { Locales, Values, ChangeValues } from './types';

const Adult: FC<{
  values: Values;
  changeValues: ChangeValues;
  locales: Locales;
}> = ({ values, changeValues, locales }) => (
  <div className="input boolean player_adult">
    <input
      type="checkbox"
      checked={values.adult}
      onChange={() => changeValues({ adult: !values.adult })}
      name="player[adult]"
      id="player_adult"
    />
    <label htmlFor="player_adult">
      {values.country === 'EE' ? locales.attributes.adult_ee : locales.attributes.adult}
    </label>
  </div>
);

export default Adult;
